import { Registry } from '../../loader/di/registry.js';
import { selectTemplate } from '../../loader/essentials/config-selector.js';
import { CONFIG_RESOLVER } from '../../loader/token.js';
import { renderTemplate } from '../../utils/render-template.js';
import { Adslot } from '../modules/adslot-controller/adslot.js';
import { EffectFunction } from './index.js';

export const LOADING_SPINNER: EffectFunction = ({ loadingSpinner }: Adslot) => {
    const template = Registry.lookup(CONFIG_RESOLVER).get(selectTemplate('loadingSpinner'));
    loadingSpinner.innerHTML = renderTemplate(template);
    loadingSpinner.classList.remove('sdgRemoved');
    return () => {
        loadingSpinner.classList.add('sdgRemoved');
        loadingSpinner.innerHTML = '';
    };
};
